<section class="p-3" [ngClass]="{'app-diskusia-large': display == 'large', 'app-diskusia-mobile': display == 'mobile'}">

  <!-- <app-progress-spinner *ngIf="loading"></app-progress-spinner> -->

  <mat-dialog-content class="custom-dialog pt-2 pb-0 px-4">

    <!-- Hlavička -->
    <lib-dialog-header [titulok]="diskusia.nazov"></lib-dialog-header>

    <!-- Posuvný obsah -->
    <div class="dialog-body">

      <div i18n class="mb-2">Zobrazujú sa príspevky za posledných 90 dní.</div>

      <div>
        <div *ngFor="let p of prispevky">
          <app-podpora-prispevok [p]="p" [display]="display" (change)="nacitajPrispevky()"></app-podpora-prispevok>
        </div>
      </div>

      <div *ngIf="loading" class="loading-overlay">
        <mat-spinner></mat-spinner>
      </div>

      <!-- toto tu je cisto len kvoli skoku na koniec diskusie po zaslani prispevku -->
      <div id="spodnaCastDiskusie" #spodnaCast></div>

    </div>


  </mat-dialog-content>

  <hr/>

  <mat-dialog-actions class="dialog-footer">
    <div class="vw-100">

      <div *ngIf="!loading && !diskusia.anonym" class="app-user-input-section">
        <div class="d-flex flex-row">
          <textarea matInput class="no-border-textarea" [(ngModel)]="value"
            placeholder="Tu zadajte svoj príspevok" i18n-placeholder>
          </textarea>
          <button *ngIf="value" class="textarea-button" matSuffix mat-icon-button aria-label="Send" (click)="sendMessage(value)">
            <mat-icon>send</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="!loading && diskusia.anonym" class="app-user-input-section">
        <div class="d-flex flex-row">
          <textarea matInput class="no-border-textarea" [(ngModel)]="value" placeholder="Tu zadajte svoj príspevok" i18n-placeholder>
          </textarea>
          <button *ngIf="value" #menuTrigger="matMenuTrigger" class="textarea-button"
              matSuffix mat-icon-button [matMenuTriggerFor]="menuSend" aria-label="Send">
            <mat-icon>send</mat-icon>
          </button>

          <mat-menu #menuSend="matMenu">
            <button mat-menu-item (click)="sendMessage(value, true)">
              <mat-icon>person_off</mat-icon>
              <span i18n>Odoslať anonymne</span>
            </button>
            <button mat-menu-item (click)="sendMessage(value)">
              <mat-icon>perm_identity</mat-icon>
              <span i18n>Odoslať</span>
            </button>
          </mat-menu>

        </div>
      </div>


    </div>
  </mat-dialog-actions>

</section>


